import React from "react";
import {
  Grid,
  TableBody,
  CardContent,
  Divider,
  Card,
} from "@material-ui/core";
import TableBodyCell from "components/table/TableBodyCell";
import { BootstrapBadge } from "components/ui/BootstrapBadge";
import { readableFormatDate } from "shared/utils";
import { CustomTableWrapper } from "shared/components/CustomTableWrapper";

export const ChequeDetails = ({ data }) => {
  return (
    <Card>
      <CardContent className="card-content_head">
        <Grid container alignItems="center">
          <Grid item xs={6}>
            Cheque Details
          </Grid>
        </Grid>
      </CardContent>
      <Divider />
      <CardContent>
        <CustomTableWrapper>
          <Grid item xs={6}>
            <table className="w-full">
              <TableBody>
                <TableBodyCell className="common_table_title">Is Bounce</TableBodyCell>
                <TableBodyCell>
                  <BootstrapBadge
                    backgroundColor="#FF4961"
                    text={data["is_bounce"] === 1 ? "Yes" : "No"}
                  />
                </TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Comment</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["comment"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Status</TableBodyCell>
                <TableBodyCell className="common_table_content">
                  <BootstrapBadge
                    backgroundColor="#0ABB87"
                    text={data["status"]}
                  />
                </TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Receiving Bank Account</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["receiving_bank"]}</TableBodyCell>
              </TableBody>
            </table>
          </Grid>

          <Grid item xs={6}>
            <table className="w-full">
              <TableBody>
                <TableBodyCell className="common_table_title">Cheque No.</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["cheque_number"]}</TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Cheque Bank</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["cheque_bank_id"]}</TableBodyCell>
              </TableBody>

              <TableBody>
                <TableBodyCell className="common_table_title">Cheque Presentation Date</TableBodyCell>
                <TableBodyCell className="common_table_content">
                  {readableFormatDate(data["cheque_presentation_date"])}
                </TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Created Date</TableBodyCell>
                <TableBodyCell className="common_table_content">
                  {readableFormatDate(data["created_at"])}
                </TableBodyCell>
              </TableBody>
              <TableBody>
                <TableBodyCell className="common_table_title">Operating Bank Account</TableBodyCell>
                <TableBodyCell className="common_table_content">{data["operating_bank_account"]}</TableBodyCell>
              </TableBody>
            </table>
          </Grid>
        </CustomTableWrapper>
      </CardContent>
    </Card>
  );
};
